/** trainerForms + recurrence + createWorkout + exerciseAnalytics — español */
export const TRAINER_FORMS_ES = {
  'optForm.batchUnknownDate': 'Fecha desconocida',
  'optForm.batchBusy': 'ocupado: {clients}',
  'optForm.duration30': '30 minutos',
  'optForm.duration45': '45 minutos',
  'optForm.duration60': '1 hora',
  'optForm.duration90': '1,5 horas',
  'optForm.duration120': '2 horas',
  'optForm.durationCustom': 'Otra',

  'optForm.errPickClient': 'Selecciona al menos un cliente',
  'optForm.errPickDate': 'Elige la fecha del entreno',
  'optForm.errPickStartTime': 'Elige la hora de inicio',
  'optForm.errPickDuration': 'Elige la duración',
  'optForm.errRecurrenceDuplicateSlot': 'No puedes repetir el mismo día y hora',
  'optForm.errRecurrenceWeeks': 'Indica cuántas semanas',
  'optForm.errRecurrenceEndDate': 'Elige la fecha de fin de la serie',
  'optForm.errRecurrenceEndBeforeStart': 'La fecha de fin no puede ser anterior al entreno',
  'optForm.errNoClientWorkout': 'No hay cliente seleccionado',
  'optForm.errBuildSchedule': 'No se pudo armar el calendario. Revisa la repetición.',
  'optForm.scheduleConflictIntro': 'Horario no disponible:',
  'optForm.timeAlreadyTaken': 'Ese horario ya está ocupado',
  'optForm.successBatchPartial': 'Creados {created} de {planned} entrenos{suffix}',
  'optForm.successBatchConflictsSuffix': '. Algunas fechas chocaban',
  'optForm.errSaveWorkout': 'No se pudo {verb} el entreno',
  'optForm.verbUpdate': 'actualizar',
  'optForm.verbCreate': 'crear',
  'optForm.errCreateBatch': 'No se pudieron crear los entrenos',
  'optForm.errCreateWorkout': 'No se pudo crear el entreno',

  'optForm.titleEdit': 'Editar entreno',
  'optForm.titleCreate': 'Nuevo entreno',
  'optForm.successUpdated': '¡Entreno actualizado!',
  'optForm.successCreated': '¡Entreno creado!',

  'optForm.labelClient': 'Cliente *',
  'optForm.phClient': 'Elige cliente',
  'optForm.labelWorkoutDate': 'Fecha del entreno *',
  'optForm.labelStartTime': 'Hora de inicio *',
  'optForm.labelDuration': 'Duración *',
  'optForm.durationPlaceholder': 'Elige duración',
  'optForm.labelEndTime': 'Hora de fin *',
  'optForm.endsAt': 'Termina: {time}',

  'optForm.recurrenceHeading': 'Repetir',
  'optForm.recurrenceAdded': 'Añadidos: {n}',
  'optForm.recurrenceNoRepeat': 'No se repite',
  'optForm.recurrenceEmpty': 'Sin franjas repetidas',
  'optForm.recurrenceEmptyHint': 'Añade día y hora para empezar',
  'optForm.addDayTime': 'Añadir día y hora',
  'optForm.labelWeekday': 'Día de la semana',
  'optForm.labelTimeShort': 'Hora',

  'optForm.recurrenceEndTitle': 'Fin de la serie *',
  'optForm.recurrenceEndWeeksOpt': 'Número de semanas',
  'optForm.recurrenceEndDateOpt': 'Hasta la fecha',
  'optForm.phWeeksCount': 'Número de repeticiones',
  'optForm.ariaRecurrenceEndMethod': 'Cómo termina la serie',
  'optForm.ariaRecurrenceWeeks': 'Semanas a repetir',
  'optForm.ariaRecurrenceEndDate': 'Fecha de fin de la serie',

  'optForm.labelLocation': 'Ubicación',
  'optForm.labelGymName': 'Nombre del gimnasio *',
  'optForm.phGymName': 'Nombre del gimnasio',
  'optForm.labelGymAddress': 'Dirección',
  'optForm.phGymAddress': 'Dirección',
  'optForm.saving': 'Guardando…',
  'optForm.save': 'Guardar',
  'optForm.selectLocation': 'Elige ubicación',
  'optForm.online': 'Online',
  'optForm.addNewGym': '+ Añadir gimnasio',

  'optForm.commentLabel': 'Nota',
  'optForm.commentPlaceholder': 'Escribe una nota',
  'optForm.commentApplyAria': 'Aplicar la nota a todos los entrenos de la serie',
  'optForm.commentApplyAll': 'Aplicar a todos los entrenos',

  'optForm.deleteWorkout': 'Eliminar entreno',

  'optForm.discardTitle': '¿Descartar cambios?',
  'optForm.discardDesc': 'Hay cambios sin guardar. ¿Seguro que quieres cerrar?',
  'optForm.discardConfirm': 'Descartar',

  'optForm.conflictTitle': 'Ya hay otro entreno a esta hora',
  'optForm.conflictAsk': '¿Crearlo igualmente?',
  'optForm.conflictBatchHeading': 'Huecos ocupados en la serie (día, fecha y hora):',
  'optForm.conflictSingleHeading': 'Entrenos en conflicto:',
  'optForm.clientFallback': 'Cliente',
  'optForm.conflictWorkoutWhen': '{date}, {time}{end}',
  'optForm.conflictEndDash': ' – {end}',
  'optForm.hide': 'Ocultar',
  'optForm.showMore': 'Ver más ({n})',
  'optForm.conflictNo': 'No',
  'optForm.conflictCreating': 'Creando…',
  'optForm.conflictYes': 'Crear igualmente',

  'recurrenceUi.type.none': 'No se repite',
  'recurrenceUi.type.daily': 'Cada día',
  'recurrenceUi.type.weekly': 'Cada semana',
  'recurrenceUi.type.monthly': 'Cada mes',
  'recurrenceUi.type.weekdays': 'Días laborables',
  'recurrenceUi.type.custom': 'Personalizado',

  'recurrenceUi.freq.daily': 'Cada día',
  'recurrenceUi.freq.weekly': 'Cada semana',
  'recurrenceUi.freq.monthly': 'Cada mes',
  'recurrenceUi.freq.yearly': 'Cada año',
  'recurrenceUi.freq.interval': 'Cada N…',

  'recurrenceUi.interval.days': 'días',
  'recurrenceUi.interval.weeks': 'semanas',
  'recurrenceUi.interval.months': 'meses',

  'recurrenceUi.end.never': 'Sin fin',
  'recurrenceUi.end.count': 'Terminar tras N veces',
  'recurrenceUi.end.date': 'Terminar en una fecha',

  'recurrenceUi.labelRecurrence': 'Repetición',
  'recurrenceUi.titleCustomSettings': 'Ajustes de repetición',
  'recurrenceUi.labelFrequency': 'Frecuencia',
  'recurrenceUi.labelInterval': 'Intervalo',
  'recurrenceUi.labelIntervalType': 'Tipo',
  'recurrenceUi.labelWeekdays': 'Días de la semana',
  'recurrenceUi.labelEnd': 'Termina',
  'recurrenceUi.labelEndCount': 'Número de veces',
  'recurrenceUi.labelEndDate': 'Fecha de fin',
  'recurrenceUi.titleEndSection': 'Fin de la repetición',
  'recurrenceUi.labelEndTypeTop': 'Termina',
  'recurrenceUi.labelRepeatCount': 'Repeticiones',
  'recurrenceUi.phRepeatExample': 'p. ej. 10',
  'recurrenceUi.hintRepeatCount': 'El entreno se repetirá tantas veces',
  'recurrenceUi.labelEndDateSection': 'Fecha de fin',
  'recurrenceUi.hintEndDate': 'Incluye esta fecha como último día',

  'recurrenceUi.summaryNone': 'No se repite',
  'recurrenceUi.summaryPrefix': 'Repite: ',
  'recurrenceUi.summaryDaily': 'cada día',
  'recurrenceUi.summaryWeekly': 'cada semana',
  'recurrenceUi.summaryMonthly': 'cada mes',
  'recurrenceUi.summaryWeekdays': 'lunes a viernes',
  'recurrenceUi.summaryEveryNDays': 'cada {n} días',
  'recurrenceUi.summaryEveryNWeeks': 'cada {n} semanas',
  'recurrenceUi.summaryEveryNMonths': 'cada {n} meses',
  'recurrenceUi.summaryEveryDayFallback': 'cada día',
  'recurrenceUi.summaryOnDays': ' los {days}',
  'recurrenceUi.summaryNTimes': ' ({n}×)',
  'recurrenceUi.summaryUntil': ' hasta {date}',

  'createWorkout.saving': 'Creando…',
  'createWorkout.errPickEndTime': 'Elige hora de fin',
  'createWorkout.errEndAfterStart': 'La hora de fin debe ser posterior al inicio',
  'createWorkout.errRecurrenceFrequency': 'Elige la frecuencia',
  'createWorkout.errPickWeekday': 'Elige al menos un día',
  'createWorkout.labelClients': 'Cliente(s) *',
  'createWorkout.phClients': 'Elige cliente o empieza a escribir',
  'createWorkout.phStartTime': 'Fecha y hora de inicio',
  'createWorkout.labelEndTime': 'Hora de fin *',
  'createWorkout.phEndTime': 'Fecha y hora de fin',
  'createWorkout.phLocation': 'Elige o escribe ubicación',
  'createWorkout.locationNotFound': 'Ubicación no encontrada',
  'createWorkout.locGym': 'Gimnasio',
  'createWorkout.locHome': 'Casa',
  'createWorkout.locOutdoor': 'Aire libre',
  'createWorkout.locOnline': 'Online',

  'exerciseAnalytics.tabSummary': 'Resumen',
  'exerciseAnalytics.tabHistory': 'Historial',
  'exerciseAnalytics.progressTitle': 'Progreso',
  'exerciseAnalytics.progressDesc': 'Cómo evolucionan tus marcas',
  'exerciseAnalytics.metricHeaviestShort': 'Peso',
  'exerciseAnalytics.metricVolumeShort': 'Volumen',
  'exerciseAnalytics.metricHeaviestAxis': 'Peso (kg)',
  'exerciseAnalytics.metricVolumeAxis': 'Volumen (kg)',
  'exerciseAnalytics.timeWeek': 'Semana',
  'exerciseAnalytics.timeMonth': 'Mes',
  'exerciseAnalytics.timeYear': 'Año',
  'exerciseAnalytics.timeAll': 'Todo el periodo',
  'exerciseAnalytics.loadingChart': 'Cargando…',
  'exerciseAnalytics.noChartData': 'Sin datos que mostrar',
  'exerciseAnalytics.recordsTitle': 'Records personales',
  'exerciseAnalytics.recordsDesc': 'Mejores marcas en todas las sesiones',
  'exerciseAnalytics.workingWeight': 'Peso de trabajo',
  'exerciseAnalytics.editWorkingWeightTitle': 'Editar peso de trabajo',
  'exerciseAnalytics.bestSetVolume': 'Mejor volumen en una serie',
  'exerciseAnalytics.bestSessionVolume': 'Mejor volumen de la sesión',
  'exerciseAnalytics.noData': 'Sin datos',
  'exerciseAnalytics.loadingShort': 'Cargando…',
  'exerciseAnalytics.editWwDialogTitle': 'Peso de trabajo',
  'exerciseAnalytics.editWwDialogDesc':
    'Peso manual para «{name}». Déjalo vacío para borrarlo.',
  'exerciseAnalytics.labelWwKg': 'Peso de trabajo (kg)',
  'exerciseAnalytics.phWw': 'p. ej. 40',
  'exerciseAnalytics.errInvalidWeight': 'Introduce un peso válido',
  'exerciseAnalytics.errUpdateWeight': 'No se pudo actualizar el peso',
  'exerciseAnalytics.saving': 'Guardando…',
  'exerciseAnalytics.loadingHistory': 'Cargando historial…',
  'exerciseAnalytics.unknownDate': 'Fecha desconocida',
  'exerciseAnalytics.openWorkout': 'Abrir entreno',
  'exerciseAnalytics.setN': 'Serie {n}',
  'exerciseAnalytics.weight': 'Peso',
  'exerciseAnalytics.reps': 'Repeticiones',
  'exerciseAnalytics.noSetData': 'Sin datos de series',
  'exerciseAnalytics.noHistory': 'Sin historial para este ejercicio',
  'exerciseAnalytics.tooltipHeaviestUpdated': 'Peso de trabajo (actualizado)',
  'exerciseAnalytics.tooltipDate': 'Fecha: {date}',
  'exerciseAnalytics.kgValue': '{value} kg',
  'exerciseAnalytics.emDash': '—',
};
